export default __webpack_public_path__ + "static/media/tiktok.50595335.svg";